import { render, staticRenderFns } from "./RequestErrorMessage.vue?vue&type=template&id=2b3e6410&"
import script from "./RequestErrorMessage.vue?vue&type=script&lang=js&"
export * from "./RequestErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports